import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { HttpClient } from '@angular/common/http';

import { Evaluation } from '../models/evaluation/evaluation.model';
import { CodingEndpoint } from './coding-endpoint.service';




@Injectable({ providedIn: 'root'})
export class CodingService {

  constructor(private router: Router, private http: HttpClient, private codingEndpoint: CodingEndpoint) {

  }

  getCodingUIElements(protocolId?: number) {
    return this.codingEndpoint.getCodingUIElementsEndpoint<any>(protocolId);
  }

  newCodingSubmission(evaluation: Evaluation, activeTeam: number) {
    return this.codingEndpoint.getNewCodingSubmissionEndpoint<Evaluation>(evaluation, activeTeam);
  }

  recommendEvaluationForReview(currentEvaluationId: number) {
    return this.codingEndpoint.postRecommendEvaluationForReview<boolean>(currentEvaluationId);
  }

  recommendEvaluationForAdjudication(currentEvaluationId: number) {
    return this.codingEndpoint.postRecommendEvaluationForAdjudication<boolean>(currentEvaluationId);
  }

}
